import api from '../../utils/api';
import { mergeOutreachMenuPaths } from '../../routes/outreach/outreachPaths';
import { mergeContentExtraMenuPaths } from '../../menu/extraMenuPaths';
import apiformData from '../../utils/apiformData';
import {
  LOGIN,
  LOGOUT,
  GET_AUTH_USER,
  // CHANGE_PASSWORD,
  RESET_PASSWORD,
  UPDATE_AUTH_USER,
  GET_AUTH_PERMISSION,
  // UPDATE_AVATAR,
  GET_BANK,
  ADD_BANK,
  DELETE_BANK,
  SET_DEFAULT_BANK,
} from '../types';
import { setCookie, removeCookie, getCookie } from '../../utils/cookie';
import { NotificationManager } from 'react-notifications';
import subscriberApi from '../../api/subscriber';
import OneSignal from 'react-onesignal';
import authApi from '../../api/auth';

const parseMenuTree = (menuItems) => {
  return menuItems.map((menu) => {
    let paths = [];
    try {
      paths = JSON.parse(menu.path);
      if (!Array.isArray(paths)) paths = [];
    } catch (e) {
      console.warn('Path parse error:', menu.path);
      paths = [];
    }

    const menuItem = {
      name: menu.name,
      path: paths,
      is_active: menu.is_active,
    };

    if (menu.children && menu.children.length > 0) {
      menuItem.children = parseMenuTree(menu.children);
    }

    return menuItem;
  });
};

const getAllPaths = (menuItems) => {
  let paths = [];
  menuItems.forEach((menu) => {
    if (menu.path && Array.isArray(menu.path)) {
      paths.push(...menu.path);
    }
    if (menu.children && menu.children.length > 0) {
      paths.push(...getAllPaths(menu.children));
    }
  });
  return paths;
};

const completeLoginSession = (dispatch, responseData) => {
  const { user, token } = responseData;
  const userId = user.user.id;
  const role = user.role;
  const menus = user.menu || [];

  setCookie('token', token.accessToken, 7);
  localStorage.setItem('userId', userId);
  localStorage.setItem('role', role);

  const menuTree = parseMenuTree(menus);
  localStorage.setItem('menu_tree', JSON.stringify(menuTree));

  const uniquePaths = mergeContentExtraMenuPaths(
    mergeOutreachMenuPaths([...new Set(getAllPaths(menuTree))])
  );
  localStorage.setItem('menu_paths', JSON.stringify(uniquePaths));

  dispatch({ type: LOGIN, payload: responseData });
};

const getApiErrorMessage = (err, fallback) => {
  return err?.data?.message || err?.message || fallback;
};

export const login = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post('/v1/auth/login', data)
      .then((res) => {
        const { data: responseData } = res.data;

        if (responseData.requires_totp_setup) {
          resolve({
            requiresTotpSetup: true,
            pendingToken: responseData.pending_token,
            user: responseData.user,
          });
          return;
        }

        if (responseData.requires_totp) {
          resolve({
            requiresTotp: true,
            pendingToken: responseData.pending_token,
            user: responseData.user,
          });
          return;
        }

        completeLoginSession(dispatch, responseData);
        resolve({ requiresTotp: false });
      })
      .catch((err) => {
        NotificationManager.error(getApiErrorMessage(err, 'Tên đăng nhập hoặc mật khẩu không đúng'));
        reject(err);
      });
  });
};

export const verifyTotpLogin = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return authApi
      .verifyTotpLogin(data)
      .then((res) => {
        const { data: responseData } = res.data;
        completeLoginSession(dispatch, responseData);
        resolve(true);
      })
      .catch((err) => {
        NotificationManager.error(getApiErrorMessage(err, 'Mã xác thực 2FA không đúng. Thử lại hoặc đăng nhập lại.'));
        reject(err);
      });
  });
};

export const setupTotpLogin = (data) => () => {
  return new Promise((resolve, reject) => {
    return authApi
      .loginSetupTotp(data)
      .then((res) => {
        resolve(res.data?.data || null);
      })
      .catch((err) => {
        NotificationManager.error(getApiErrorMessage(err, 'Không thể tạo mã QR 2FA'));
        reject(err);
      });
  });
};

export const enableTotpLogin = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return authApi
      .loginEnableTotp(data)
      .then((res) => {
        const { data: responseData } = res.data;
        completeLoginSession(dispatch, responseData);
        resolve(true);
      })
      .catch((err) => {
        NotificationManager.error(getApiErrorMessage(err, 'Mã xác thực 2FA không đúng.'));
        reject(err);
      });
  });
};

export const getAuthUser = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .get('/v1/auth/loginToken')
      .then((res) => {
        dispatch({ type: GET_AUTH_USER, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const updateAuthUser = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post('/client/account/updateProfile', data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
        NotificationManager.success('Cập nhật thành công!');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const changePassword = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api.post('/auth/password', data);

      resolve(true);
    } catch (err) {
      reject(err);
    }
  });
};

export const resetPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post('/reset-password', data)
      .then((res) => {
        dispatch({ type: RESET_PASSWORD, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        let message = 'Đã có lỗi xảy ra, vui lòng thử lại!';
        if (err.response.data.msg) message = err.response.data.msg;
        NotificationManager.error(message);
        reject(err);
      });
  });
};
export const logout = () => (dispatch) => { 
  return new Promise((resolve, reject) => { 
    removeCookie('token');
    
    localStorage.removeItem('role');
    localStorage.removeItem('role_config');
    localStorage.removeItem('userId');
    localStorage.removeItem('menu_tree');
    localStorage.removeItem('menu_paths');

    // localStorage.removeItem('onesignal_device_id'); // Xóa OneSignal Device ID khi logout
    
    dispatch({ type: LOGOUT }); 
    resolve(true); 
  }); 
};
export const getAuthPermission = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .get('/permission/get_all_permission_of_user')
      .then((res) => {
        dispatch({ type: GET_AUTH_PERMISSION, payload: res.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const updateAvatar = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    apiformData
      .post(`/users/account/update/avatar/${id}`, data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.user });
        resolve(res.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const getBank = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .get('/client/account/myBankAccount')
      .then((res) => {
        dispatch({ type: GET_BANK, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const addBank = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post('/client/account/addBankAccount', data)
      .then((res) => {
        dispatch({ type: ADD_BANK, payload: res.data.data });
        NotificationManager.success('Thêm thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const deleteBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .delete(`/client/account/deleteBankAccount/${id}`)
      .then((res) => {
        dispatch({ type: DELETE_BANK, payload: res.data.data });
        NotificationManager.success('Cập nhật thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const setDefaultBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api
      .post(`/client/account/setBankAccountDefault/${id}`)
      .then((res) => {
        dispatch({ type: SET_DEFAULT_BANK, payload: res.data.data });

        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};
